import PageFAQ from './PageFAQ';

export default PageFAQ;
